const RECORDING_FLAGS = {
  comment: 'comment-button-recording',
  recordUser: 'recordUser',
};

export default RECORDING_FLAGS;
